export default function initAncoraProdutos() {
    const nav = document.querySelector('.js-ancora');
    const links = document.querySelectorAll('.js-ancora-link');
    const sections = [
        document.getElementById('descricao-completa'),
        document.getElementById('ficha-tecnica'),
        document.getElementById('downloads')
    ].filter(el => el !== null); // Garante que só observa o que existe

    if (!nav) return;

    // 1. LÓGICA STICKY
    const navOffset = nav.offsetTop;

    window.addEventListener('scroll', () => {
        if (window.pageYOffset >= navOffset) {
            nav.classList.add('is-sticky');
        } else {
            nav.classList.remove('is-sticky');
        }
    });

    // 2. CLIQUE SUAVE COM COMPENSAÇÃO DE ALTURA
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const id = link.getAttribute('href');
            const targetSection = document.querySelector(id);
            const navHeight = nav.offsetHeight;

            if (targetSection) {
                const targetPosition = targetSection.offsetTop - navHeight - 20; // 20px de respiro
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // 3. SCROLLSPY (Intersection Observer)
    const observerOptions = {
        root: null,
        rootMargin: `-${nav.offsetHeight + 50}px 0px -70% 0px`, // Ajusta área de detecção
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');

                links.forEach(link => {
                    link.classList.remove('is-active');
                    if (link.getAttribute('href') === `#${id}`) {
                        link.classList.add('is-active');
                    }
                });
            }
        });
    }, observerOptions);

    sections.forEach(section => observer.observe(section));
}